import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "qun",
  "use": "qun-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"qun\"><defs><style type=\"text/css\"></style></defs><path d=\"M222.7072 802.6496V455.5008l28.9664-57.92H78.0288l28.9536 57.92v347.1488zM511.936 50.4192L49.0624 339.776h925.8624L511.936 50.4192z m0 231.5648a57.9072 57.9072 0 0 1-57.92-57.92 57.8176 57.8176 0 0 1 57.92-57.92 57.8944 57.8944 0 0 1 57.9072 57.92 57.8816 57.8816 0 0 1-57.9072 57.92zM78.0288 860.5696l-28.9664 115.7248h925.8624l-28.9536-115.7248zM917.1328 802.6496V455.5008l28.9664-57.92H772.4672l28.9536 57.92v347.1488zM454.144 802.6496V455.5008l28.9536-57.92H309.4656l28.9536 57.92v347.1488zM685.5808 802.6496V455.5008l28.9536-57.92H540.9024l28.9536 57.92v347.1488z\" p-id=\"210727\" fill=\"#29A1F7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/qun.svg
// module id = zWZQ
// module chunks = 38